import React from "react";

interface AccessibleAlertProps {
  message: string;
  type?: "success" | "error" | "warning";
  onClose?: () => void;
}

const AccessibleAlert: React.FC<AccessibleAlertProps> = ({ message, type = "success", onClose }) => {
  return (
    <div
      role="alert"
      aria-live="assertive"
      className={`accessible-alert accessible-alert--${type}`}
      style={{
        border: "1px solid #ccc",
        background: type === "success" ? "#e6ffed" : type === "error" ? "#ffe6e6" : "#fffbe6",
        color: type === "success" ? "#155724" : type === "error" ? "#721c24" : "#856404",
        padding: "1em",
        margin: "1em 0",
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
      }}
    >
      <span>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          aria-label="Close alert"
          style={{
            background: "none",
            border: "none",
            color: "inherit",
            fontSize: "1.2em",
            cursor: "pointer"
          }}
        >
          ×
        </button>
      )}
    </div>
  );
};

export default AccessibleAlert;
